<template>
<div>
    <div v-if="!documents.length" style="color: gray;">No documents uploaded</div>
    <div v-for="doc in documents" :key="doc.id" class="d-flex align-items-center justify-content-between py-2" style="border-bottom: 1px solid #f0f0f0; gap: 12px;">
        <div class="d-flex align-items-center" style="gap: 10px;">
            <img v-if="isImage(doc.file)" :src="doc.file" style="height: 40px; width: 40px; object-fit: cover; border-radius: 4px;" alt="" />
            <feather v-else type="file-text" size="22px"></feather>
            <div>
                <div>{{ labels[doc.document_type] || doc.document_type }}</div>
                <div v-if="meta(doc)" style="color: gray; font-size: 12px;">{{ meta(doc) }}</div>
            </div>
        </div>
        <a :href="doc.file" target="_blank" rel="noopener noreferrer">
            <b-button size="sm" variant="outline-primary">Open</b-button>
        </a>
    </div>
</div>
</template>

<script>
import { DOCUMENT_LABELS } from './skilled-professional-helpers';

export default {
    name: 'SpDocumentList',
    props: {
        documents: { type: Array, default: () => [] }
    },
    data() {
        return { labels: DOCUMENT_LABELS };
    },
    methods: {
        isImage(url) {
            return /\.(png|jpe?g|gif|webp)$/i.test(url || '');
        },
        meta(doc) {
            const parts = [];
            if (doc.title) parts.push(doc.title);
            if (doc.document_date) parts.push('dated ' + doc.document_date);
            if (doc.expiry_date) parts.push('exp ' + doc.expiry_date);
            return parts.join(' · ');
        }
    }
};
</script>
